import {
  getPlatformV1OpsOverview,
  postPlatformV1OpsSearchReindex,
  type OpsOverview,
  type ReindexAllResult,
} from '@nucleus-commerce/api-client/platform';

export const operationsApi = {
  overview: (): Promise<OpsOverview> => getPlatformV1OpsOverview(),
  /** Queues one full reindex per active or paused store; five a minute per caller. */
  reindexAll: (): Promise<ReindexAllResult> => postPlatformV1OpsSearchReindex(),
};
